import TicketsFilter from "../../../app/main/mesa_servicio_reportes/reportes/search_tickets/filter";
import Reportes from '../../../app/main/mesa_servicio_reportes/reportes';
import {useKeycloak} from "@react-keycloak/web";
import { getKeycloakRole } from '../../../app/shared-components/utils';

const Index = () => {

  const { keycloak } = useKeycloak();
  const roleKeycloak = getKeycloakRole(keycloak?.realmAccess?.roles);
  
  return (
    <>
      {['Administrador','NOC', 'Monitoreo'].includes(roleKeycloak) && (
        <>
          <div className="mb-4">
            <Reportes />
          </div>
        </>
      )}
    </>
  );
};

export default Index;
